/**
 * Converts a width or height value to a CSS string.
 * - If the value is a number, appends 'px' to it.
 * - If the value is a string that is a valid number (e.g., "70"), appends 'px' to it.
 * - If the value is a string with units or special values (e.g., "100%", "auto", "calc(...)"), returns it as-is.
 * - If the value is undefined or null, returns undefined.
 */
export const toCSSSize = (value: string | number | undefined | null): string | undefined => {
    if (value === undefined || value === null) {
        return undefined
    }
    if (typeof value === 'number') {
        return `${value}px`
    }
    if (/^-?\d+(\.\d+)?$/.test(value.trim())) {
        return `${value}px`
    }
    return value
}
